import { render, staticRenderFns } from "./CheckBook.vue?vue&type=template&id=195de12e&scoped=true&"
import script from "./CheckBook.vue?vue&type=script&lang=js&"
export * from "./CheckBook.vue?vue&type=script&lang=js&"
import style0 from "./CheckBook.vue?vue&type=style&index=0&id=195de12e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195de12e",
  null
  
)

export default component.exports